module.exports = "<div id=\"fullscreen\" class=\"btn-header transparent pull-right\">\r\n        <span> <a (click)=\"onToggle()\" title=\"Full Screen\"><i class=\"fa fa-arrows-alt\"></i></a> </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/header/full-screen/full-screen.component.html
// module id = 877
// module chunks = 29